import { useMutation } from '@apollo/client'
import clsx from 'clsx'
import { useContext } from 'react'
import { useForm } from 'react-hook-form'
import { LayoutContext } from '../../contexts/layout.context'
import {
  ADD_CIRCUIT_MUTATION,
  GET_ALL_CIRCUITS_QUERY,
} from '../../graphql/circuit.graphql'
import CircuitForm from '../circuit/CircuitForm'

const AddCircuitModal = () => {
  const { handleSubmit, control } = useForm()
  const { closeModal } = useContext(LayoutContext)
  const [addCircuitMutation, addCircuitMutationResult] = useMutation(
    ADD_CIRCUIT_MUTATION,
    {
      refetchQueries: [
        {
          query: GET_ALL_CIRCUITS_QUERY,
        },
      ],
      onCompleted: closeModal,
    },
  )

  const onSubmit = (values: { [x: string]: any }) => {
    addCircuitMutation({
      variables: {
        addCircuitInput: values,
      },
    })
  }

  const buttonClass = clsx('btn btn-primary', {
    'opacity-30': addCircuitMutationResult.loading,
  })

  return (
    <div>
      <h2 className="title">{"Ajout d'un circuit"}</h2>

      <div className="mt-8">
        <div className="text-light">
          <form onSubmit={handleSubmit(onSubmit)}>
            <CircuitForm control={control as any} />

            <div className="flex justify-end mt-6">
              <button
                className={buttonClass}
                disabled={addCircuitMutationResult.loading}
              >
                {addCircuitMutationResult.loading
                  ? 'Enregistrement...'
                  : 'Enregistrer'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddCircuitModal
